import {
  createSlice,
  createAsyncThunk,
  createSelector,
  isAnyOf,
} from '@reduxjs/toolkit';
import axios from 'axios';
import apiConfig, { API_ROUTES } from '../../globalConfig/apiConfig';

const RYDER_HOST = apiConfig.ryderHost;
const EXTERNAL_HOST = apiConfig.externalHost;
const PATH = API_ROUTES.calibration;
const API_KEY = apiConfig.apiKey;

const initialState = {
  data: {},
  loading: false,
  error: null,
};

export const calibrateReader = createAsyncThunk(
  'calibration',
  async (readerDetails) => {
    const response = await axios.post(
      `${RYDER_HOST}${PATH}`,
      {
        ...readerDetails,
      },
      {
        headers: {
          'x-api-key': API_KEY,
        },
      },
    );
    return response.data;
  },
);

export const calibrateReaderExt = createAsyncThunk(
  'calibrationExt',
  async (readerDetails) => {
    const { sessionData, token } = readerDetails;
    const response = await axios.post(
      `${EXTERNAL_HOST}${PATH}`,
      {
        ...sessionData,
      },
      {
        headers: {
          'x-api-key': API_KEY,
          Authorization: token,
        },
      },
    );
    return response.data;
  },
);

export const calibrationSlice = createSlice({
  name: 'calibration',
  initialState,
  reducers: {
    clearReaderCalibration: (state, action) => {
      let reader = action.payload;
      state.data[reader] = {};
    },
    clearAllCalibrationData: (state) => {
      state.data = {};
    },
    clearErrors: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(calibrateReaderExt.fulfilled, (state, action) => {
        let key = action.meta.arg.sessionData.expected_mac_address;
        state.loading = true;
        state.error = null;
        state.data[key] = action.payload;
      })
      .addCase(calibrateReader.fulfilled, (state, action) => {
        let key = action.meta.arg.expected_mac_address;
        state.loading = true;
        state.error = null;
        state.data[key] = action.payload;
      })
      .addMatcher(
        isAnyOf(calibrateReader.pending, calibrateReaderExt.pending),
        (state) => {
          state.loading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isAnyOf(calibrateReader.rejected, calibrateReaderExt.rejected),
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        },
      );
  },
});

export const { clearReaderCalibration, clearAllCalibrationData, clearErrors } =
  calibrationSlice.actions;
export default calibrationSlice.reducer;

/* Selectors */
export const selectCalibrationResponse = (state) =>
  state.calibrationByDevice.data;

const getMacAddress = (_, macAddress) => macAddress;

export const calibrationByMacSelector = createSelector(
  selectCalibrationResponse,
  getMacAddress,
  (calibration, macAddress) => {
    if (!calibration[macAddress]) {
      return calibration;
    }
    return calibration && calibration[macAddress];
  },
);

export const selectLastCheck = createSelector(
  calibrationByMacSelector,
  (response) => {
    return response.is_last_check_complete;
  },
);
